import { Link } from 'react-router-dom';
import { OUTCOME_LABEL, type AthleteLesson } from '../api/use-athlete-lessons.js';
import { firstLine } from '../api/first-line.js';
import { when } from './when.js';

/**
 * One of the athlete's lessons as a row: when, what, with whom, and the first
 * line of the plan. Shared by My lessons and the athlete's Home, which draw it
 * the same way (Athlete Portal canvas, rows 3 and 6). A clinic leads with its
 * title and the time follows (Matthew, 31 October).
 */
export function LessonRow({
  lesson,
  withPlace = false,
  showOutcome = false,
}: {
  lesson: AthleteLesson;
  withPlace?: boolean;
  showOutcome?: boolean;
}) {
  const plan = lesson.practice_plan ? firstLine(lesson.practice_plan) : '';
  const detail = [
    lesson.is_clinic ? when(lesson.start) : (lesson.product_name ?? lesson.service_name),
    lesson.coach_name ? `Coach ${lesson.coach_name}` : '',
    withPlace ? lesson.facility_name : '',
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <Link className="hour-row" to={`/my/${lesson.lesson_id}`}>
      <span className="hour-row-text">
        <span className="name">{lesson.is_clinic ? lesson.product_name : when(lesson.start)}</span>
        <span className="detail">{detail}</span>
        {plan ? <span className="sub-line excerpt">Plan: {plan}</span> : null}
      </span>
      {showOutcome ? (
        <span className={`outcome ${lesson.outcome.replace('_', '-')}`}>{OUTCOME_LABEL[lesson.outcome]}</span>
      ) : null}
      <span className="chevron" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
